import { RefCarePlanProblemResponse } from '~/lib/types/carePlan/RefCarePlanProblemResponse';
import {
  ChakraButton,
  Text,
  EquipUIFireflyV2Theme,
  Tag,
  TagColor,
} from '@equip.health/ui';

type Props = {
  problem: RefCarePlanProblemResponse;
  onClick: () => void;
  isRecommended?: boolean;
};

const { secondary } = EquipUIFireflyV2Theme.colors;

export const AddProblemModalProblemButton = ({
  problem,
  onClick,
  isRecommended = false,
}: Props) => {
  return (
    <ChakraButton
      _hover={{
        background: secondary[5],
      }}
      alignItems="center"
      background="neutral.white"
      borderColor="neutral.line"
      borderRadius="12px"
      borderWidth="1px"
      display="flex"
      flexDirection="row"
      gap="12px"
      height="unset"
      justifyContent="flex-start"
      marginBottom="8px"
      onClick={onClick}
      padding="18px"
      width="100%"
    >
      <Text variant="bodyMedium">{problem.label}</Text>
      {isRecommended && (
        <Tag
          color={TagColor.periwinkle}
          id={`recommended-problem-${problem.code}`}
          value="Recommended"
        />
      )}
    </ChakraButton>
  );
};
